import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53182751")

_pushScopeId("data-v-53182751")
const _hoisted_1 = { class: "main-page-title flex flex--valign-c flex--halign-c flex--gap-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "text text--size-14 text--accent-gray-a" }, "•", -1)
const _hoisted_3 = {
  key: 0,
  class: "main-page-title-content main-page-title-content--current text text--size-18 text--semi-bold text--accent-gray-a text--uppercase"
}
const _hoisted_4 = {
  key: 0,
  class: "main-page-title-content text text--size-22 text--accent-gray-a text--bold"
}
const _hoisted_5 = {
  key: 2,
  class: "main-page-title-content main-page-title-content--current text text--size-18 text--semi-bold text--accent-gray-a text--uppercase"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text text--size-14 text--accent-gray-a" }, "•", -1)
const _hoisted_7 = { class: "main-page-content flex flex--v flex--valign-c flex--gap-60" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    id: _ctx.titleId,
    class: ["main-page flex flex--v flex--valign-c flex--gap-30", { 'main-page--gap': _ctx.gap, 'disable-animation': _ctx.disableAnimation }]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.title)
        ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.title), 1))
        : (_ctx.breadCrumbTitles)
          ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.breadCrumbTitles, (breadCrumbTitle, index) => {
              return (_openBlock(), _createBlock(_Fragment, { key: breadCrumbTitle }, [
                (index > 0)
                  ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(">")))
                  : _createCommentVNode("", true),
                _createVNode("span", {
                  class: ["main-page-title-content text text--size-18 text--semi-bold text--accent-gray-a text--uppercase", { 'main-page-title-content--current': index + 1 >= _ctx.breadCrumbTitles.length }]
                }, _toDisplayString(breadCrumbTitle), 3)
              ], 64))
            }), 128))
          : (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString("No title"))),
      _hoisted_6
    ]),
    _createVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 10, ["id"]))
})